var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignVerticalBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 976v-60h800v60H80Zm210-160V176h100v640H290Zm280 0V416h100v400H570Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignVerticalBottom);
export default __webpack_public_path__ + "static/media/align_vertical_bottom.118cb4300446e33651f0424d2440f71e.svg";
export { ForwardRef as ReactComponent };